import React, { createContext, useContext, useState } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [cartForOrder, setCartForOrder] = useState(null);

  const addToCart = (item) => {
    setCart([...cart, item]);
  };

  const removeFromCart = (index) => {
    setCart(cart.filter((_, i) => i !== index));
  };

  const clearCart = () => {
    setCart([]);
    setCartForOrder(null);
  };

  const getTotalPrice = () => {
    return cart.reduce((total, item) => {
      const priceNum = parseFloat(item.price.replace('€', '').replace(',', '.'));
      return total + priceNum;
    }, 0).toFixed(2);
  };

  const prepareForOrder = () => {
    setCartForOrder({
      items: cart,
      total: getTotalPrice()
    });
  };

  return (
    <CartContext.Provider value={{ 
      cart, 
      addToCart, 
      removeFromCart, 
      clearCart, 
      getTotalPrice,
      prepareForOrder,
      cartForOrder,
      setCartForOrder
    }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};
